import i18n from '@/plugins/i18n'

const menu = [
  {
    name: i18n.t('projects._'),
    link: { name: 'projects' },
    icon: 'work'
  },
  {
    name: i18n.t('resources._'),
    link: { name: 'resources' },
    icon: 'group'
  },
  {
    name: i18n.t('analysis._'),
    link: { name: 'portfolio' },
    icon: 'remove_red_eye'
  }
  // {
  //   name: 'Calendar',
  //   link: { name: 'calendar' },
  //   icon: 'event'
  // },
]

const organizationMenu = [
  {
    name: i18n.t('organization.settings'),
    icon: 'settings',
    items: [
      {
        name: i18n.t('organization.settings'),
        link: { name: 'organization-settings' },
        icon: 'settings'
      },
      {
        name: i18n.t('customFields._'),
        link: { name: 'organization-fields' },
        icon: 'text_fields'
      },
      {
        name: i18n.t('auth.users'),
        link: { name: 'users' },
        icon: 'group'
      }
      // {
      //   name: 'Documentation',
      //   link: { name: 'documentation' },
      //   icon: 'documents'
      // },
      // {
      //   name: 'Expenses',
      //   link: { name: 'organization-expenses' },
      //   icon: 'attach_money'
      // }
    ]
  }
]

const adminMenu = [
  // {
  //   name: 'Admin',
  //   icon: 'event_seat',
  //   link: { name: 'admin' }
  // }
]

export default menu.concat(organizationMenu, adminMenu)
